var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1118_20616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.37047 6.30234C0.870625 6.30344 0.464844 6.70922 0.464844 7.20906V11.4069C0.465335 11.6469 0.560907 11.877 0.730638 12.0467C0.900369 12.2164 1.13043 12.312 1.37047 12.3125H1.9775V6.29688L1.37047 6.30234ZM12.6569 6.30234C13.1567 6.30344 13.5625 6.70922 13.5625 7.20906V11.4069C13.5614 11.9067 13.1567 12.3125 12.6569 12.3136H12.0498V6.29797L12.6569 6.30234Z",
    fill: "#C62828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.378 6.45106L12.3648 5.35731C12.3616 4.887 11.9788 4.50747 11.5084 4.50966H7.33359V3.04294C7.8925 2.8581 8.19656 2.25544 8.01172 1.69653C7.82688 1.13763 7.22422 0.833564 6.66531 1.01841C6.10641 1.20325 5.80234 1.80591 5.98719 2.36481C6.03937 2.52297 6.12789 2.6667 6.24566 2.78447C6.36342 2.90224 6.50715 2.99076 6.66531 3.04294V4.51513H2.49156C2.02344 4.51622 1.64391 4.89466 1.64062 5.36278V13.2137C1.64391 13.6818 2.02344 14.0603 2.49156 14.0625H11.5084C11.9788 14.0636 12.3616 13.684 12.3648 13.2137V12.4076H12.378V6.45106Z",
    fill: "#90A4AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 2.46875C6.75828 2.46875 6.5625 2.27297 6.5625 2.03125C6.5625 1.78953 6.75828 1.59375 7 1.59375C7.24172 1.59375 7.4375 1.78953 7.4375 2.03125C7.4375 2.27297 7.24172 2.46875 7 2.46875Z",
    fill: "#C62828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82885 10.8304H9.17213C9.55057 10.8304 9.85791 11.1378 9.85791 11.5162V11.5786C9.85791 11.957 9.55057 12.2644 9.17213 12.2644H4.82885C4.45041 12.2644 4.14307 11.957 4.14307 11.5786V11.5162C4.14307 11.1378 4.45041 10.8304 4.82885 10.8304Z",
    fill: "url(#paint0_linear_1118_20616)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.87012 10.8326H6.12824V12.2644H5.87012V10.8326Z",
    fill: "url(#paint1_linear_1118_20616)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87744 10.8326H7.13557V12.2644H6.87744V10.8326Z",
    fill: "url(#paint2_linear_1118_20616)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8717 10.8326H8.12983V12.2644H7.8717V10.8326Z",
    fill: "url(#paint3_linear_1118_20616)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.92725 10.8326H9.18537V12.2644H8.92725V10.8326Z",
    fill: "url(#paint4_linear_1118_20616)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8147 10.8304H5.07282V12.2622H4.8147V10.8304Z",
    fill: "url(#paint5_linear_1118_20616)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99996 9.83299H6.41699C6.35684 9.83299 6.30762 9.78377 6.30762 9.72362C6.30762 9.70612 6.31199 9.68971 6.31965 9.6744L6.61934 9.08268L6.90262 8.55987C6.91189 8.54238 6.92574 8.52775 6.9427 8.51755C6.95966 8.50734 6.97908 8.50195 6.99887 8.50195C7.01866 8.50195 7.03807 8.50734 7.05503 8.51755C7.07199 8.52775 7.08585 8.54238 7.09512 8.55987L7.38059 9.10674L7.67699 9.6744C7.70434 9.72799 7.68356 9.79362 7.62996 9.82206C7.61465 9.82971 7.59824 9.83409 7.58074 9.83409L6.99996 9.83299Z",
    fill: "#C62828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6637 9.06519C5.35837 9.06519 5.92151 8.50204 5.92151 7.80737C5.92151 7.1127 5.35837 6.54956 4.6637 6.54956C3.96903 6.54956 3.40588 7.1127 3.40588 7.80737C3.40588 8.50204 3.96903 9.06519 4.6637 9.06519Z",
    fill: "url(#paint6_radial_1118_20616)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6637 9.06519C5.35837 9.06519 5.92151 8.50204 5.92151 7.80737C5.92151 7.1127 5.35837 6.54956 4.6637 6.54956C3.96903 6.54956 3.40588 7.1127 3.40588 7.80737C3.40588 8.50204 3.96903 9.06519 4.6637 9.06519Z",
    stroke: "url(#paint7_linear_1118_20616)",
    strokeWidth: 0.375,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29688 6.54626C8.60234 6.54626 8.03906 7.10955 8.03906 7.80408C8.03906 8.49861 8.60234 9.06189 9.29688 9.06189C9.99141 9.06189 10.5547 8.49861 10.5547 7.80408C10.5536 7.10955 9.99141 6.54736 9.29688 6.54626Z",
    fill: "url(#paint8_radial_1118_20616)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29688 6.54626C8.60234 6.54626 8.03906 7.10955 8.03906 7.80408C8.03906 8.49861 8.60234 9.06189 9.29688 9.06189C9.99141 9.06189 10.5547 8.49861 10.5547 7.80408C10.5536 7.10955 9.99141 6.54736 9.29688 6.54626Z",
    stroke: "url(#paint9_linear_1118_20616)",
    strokeWidth: 0.375,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1118_20616",
    x1: 7.00049,
    y1: 12.2644,
    x2: 7.00049,
    y2: 10.8304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAEAEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1118_20616",
    x1: 5.99918,
    y1: 12.2644,
    x2: 5.99918,
    y2: 10.8326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1118_20616",
    x1: 7.0065,
    y1: 12.2644,
    x2: 7.0065,
    y2: 10.8326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1118_20616",
    x1: 8.00077,
    y1: 12.2644,
    x2: 8.00077,
    y2: 10.8326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1118_20616",
    x1: 9.05631,
    y1: 12.2644,
    x2: 9.05631,
    y2: 10.8326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1118_20616",
    x1: 4.94376,
    y1: 12.2622,
    x2: 4.94376,
    y2: 10.8304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1118_20616",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.6637 7.80737) scale(1.25781)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1118_20616",
    x1: 3.29651,
    y1: 7.80737,
    x2: 6.03088,
    y2: 7.80737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1118_20616",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.29141 7.80408) scale(1.25781)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1118_20616",
    x1: 7.92422,
    y1: 7.80408,
    x2: 10.6586,
    y2: 7.80408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1118_20616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.63aab47a8f395d218202c93811e1ba75.svg";
export { ForwardRef as ReactComponent };